import { computeKeyInsights } from '@resistapp/client/data-utils/key-insights/compute-key-insights';
import { OverviewLineData } from '@resistapp/client/data-utils/plot-data/build-overview-line-data';
import { GetGroup } from '@resistapp/common/assays';
import { KeyInsights } from '@resistapp/common/key-insights/types';
import { MetricMode, ProcessMode, getAllOriginalSamplingPointIds } from '@resistapp/common/types';
import { chain, Dictionary } from 'lodash';

export function buildKeyInsightsBySite(
  siteTrendDataSeries: OverviewLineData,
  defaultProcessMode: ProcessMode,
  getGroup: GetGroup,
  metricMode: MetricMode,
): Dictionary<KeyInsights | null> {
  const keyInsightsBySite = siteTrendDataSeries.reduce<Dictionary<KeyInsights | null>>((acc, siteSeries) => {
    if (!siteSeries.length) {
      return acc;
    }

    const originalSmplPntIds = chain(siteSeries)
      .flatMap(datum => getAllOriginalSamplingPointIds(datum.samplingPoint, datum.samplingPointAfter))
      .uniq()
      .value();

    if (!originalSmplPntIds.length) {
      return acc;
    }

    const canonicalSmplPntId = originalSmplPntIds[0];
    const computedInsight = computeKeyInsights(siteSeries, defaultProcessMode, getGroup, canonicalSmplPntId, metricMode);

    return originalSmplPntIds.reduce<Dictionary<KeyInsights | null>>((accLocal, smplPntId) => {
      accLocal[smplPntId] = computedInsight;
      return accLocal;
    }, acc);
  }, {});

  return keyInsightsBySite;
}
